import { DataLinkPage } from '../../DataLink';
import {
  DataImage,
  DataImageMindMap,
  DataPreviewArticleImage as DPAImage,
} from '../../DataAssets';

const DataArticle = {
  path: DataLinkPage.edu_apaItuBottomryRespondia,
  preview: {
    title: [
      {
        text: 'Apa itu ',
      },
      {
        text: 'Bottomry',
        type: 'italic',
      },
      {
        text: ' dan ',
      },
      {
        text: 'Respondia',
        type: 'italic',
      },
      {
        text: ' ?',
      },
    ],
    subInfo: {
      author: 'Rivo Bifa',
      linkProfile: DataLinkPage.author_rivoBifa,
      timestamp: 'Selasa, 18 Januari 2022',
      location: 'Jakarta',
    },
    content: [
      {
        paragraph: [
          [
            {
              text: 'Artikel ini membahas tentang bagaimana penerapan kontrak ',
            },
            {
              text: 'Bottomry',
              type: 'ins-term',
            },
            {
              text: ' dan kontrak ',
            },
            {
              text: 'Respondia',
              type: 'ins-term',
            },
            {
              text: ' yang dikenal oleh kalangan pelaku asuransi sebagai kontrak jadul dari praktik mirip asuransi.',
            },
          ],
        ],
      },
      {
        previewArticle: DPAImage.apaItuBottomryRespondia,
      },
    ],
  },
  section: [
    {
      content: [
        {
          paragraph: [
            [
              {
                text: 'Ya, ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' dan ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' merupakan kontrak dari praktik mirip asuransi yang pertama kali ditemukan oleh bangsa ',
              },
              {
                text: 'Babylonia',
                type: 'link',
                path: 'https://www.ancient.eu/babylon/',
              },
              {
                text: ' mulai dari kebiasaan hingga diberi kekuatan hukum melalui ',
              },
              {
                text: 'Code of Hammurabi',
                type: 'link',
                path: 'https://www.history.com/topics/ancient-history/hammurabi',
              },
              {
                text: '.',
              },
            ],
            [
              {
                text: 'Gue',
                type: 'italic',
              },
              {
                text: ' pikir udah banyak literatur ',
              },
              {
                text: 'online',
                type: 'italic',
              },
              {
                text: ' maupun ',
              },
              {
                text: 'offline',
                type: 'italic',
              },
              {
                text: ' yang membicarakan definisi kedua istilah tersebut jadi singkatnya kita bisa aja bilang kalau:',
              },
            ],
          ],
        },
        {
          list: {
            content: [
              [
                {
                  text: 'Bottomry',
                  type: 'ins-term',
                },
                {
                  text: ' adalah kontrak pinjaman atas jaminan kapal.',
                },
              ],
              [
                {
                  text: 'Respondia',
                  type: 'ins-term',
                },
                {
                  text: ' adalah kontrak pinjaman atas jaminan barang dagangan.',
                },
              ],
            ],
          },
        },
        {
          paragraph: [
            [
              {
                text: 'Nah di sini ',
              },
              {
                text: 'gue',
                type: 'italic',
              },
              {
                text: ' mau ',
              },
              {
                text: 'lo',
                type: 'italic',
              },
              {
                text: ' paham esensi dari ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' dan ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' supaya ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' keliru nantinya, karena kekeliruan ini bisa jadi ',
              },
              {
                text: 'domino effect',
                type: 'italic',
              },
              {
                text: ' yang tidak ada abisnya kalau tidak diperbaiki. ',
              },
              {
                text: 'Yogss',
                type: 'italic',
              },
              {
                text: ', langsung aja ',
              },
              {
                text: 'skurttt',
                type: 'italic',
              },
              {
                text: '...',
              },
            ],
          ],
        },
      ],
    },
    {
      title: [
        {
          text: 'Bottomry',
          type: 'italic',
        },
      ],
      content: [
        // {
        //   paragraph: [
        //     [
        //       {
        //         text: 'Gue',
        //         type: 'italic',
        //       },
        //       {
        //         text: ' punya referensi yang cukup bagus untuk definisi dari ',
        //       },
        //       {
        //         text: 'Bottomry',
        //         type: 'ins-term',
        //       },
        //       {
        //         text: ' dan ',
        //       },
        //       {
        //         text: 'lo',
        //         type: 'italic',
        //       },
        //       {
        //         text: ' bisa baca di bawah ini.',
        //       },
        //     ],
        //   ],
        // },
        {
          quote: {
            content: [
              {
                text: '1246. ',
                type: 'italic',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' is a contract in the nature of mortgage, by which the ship owner, or the master on his behalf, pledges the keel or bottom of the ship, pars pro toto, as security for money which he borrows for the use of the ship in contemplation of particular voyage, or for a particular and fixed of time; and it is stipulated that if the ship should be lost in the course of the voyage or during that time, by any of the perils enumerated in the contract, the lender shall loss his money, but if the ship should arrive in safety, then he shall recieve back his principal, and also the interest, agreed upon, which is generally called marine interest, however this may exceed the usual interest for the use of the money.',
                type: 'italic',
              },
            ],
            author: {
              text: 'INSTITUTE OF AMERICAN LAW',
              path: 'https://books.google.co.id/books?id=oIJeUuihvDkC&pg=PA308&lpg=PA308&dq=1246.+Bottomry&source=bl&ots=DckXCNEz0z&sig=ACfU3U27WgqEBrvdJailWuHey_lqxNmWKA&hl=en&sa=X&ved=2ahUKEwiKzL7n6tftAhUe4XMBHViqBfkQ6AEwA3oECAYQAg#v=onepage&q=1246.%20Bottomry&f=false',
            },
          },
        },
        {
          paragraph: [
            // [
            //   {
            //     text: 'Nah lohh, bingung kan… Hehe',
            //   },
            // ],
            [
              {
                text: 'Dari definisi di atas, kita bisa ngejabarin dalam ',
              },
              {
                text: 'human language',
                type: 'italic',
              },
              {
                text: '-nya orang Indonesia bahwa ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' adalah sebuah kontrak di mana seseorang (Peminjam) meminjam uang untuk menggunakan kapalnya dengan jaminannya adalah kapalnya itu sendiri kepada orang lain (Pemberi pinjaman), dengan ketentuan apabila dalam perjalanan kapal itu hilang maka Pemberi pinjaman juga kehilangan uang yang dia pinjamkan, tapi apabila kapal itu selamat maka Pemberi pinjaman akan menerima kembali uang yang dipinjam beserta bunga.',
              },
            ],
            [
              {
                text: 'Sebelumnya, di atas tadi, gua udah sampein definisi singkat dari ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },

              {
                text: ', yaitu kontrak pinjaman atas ',
              },
              {
                text: 'jaminan kapal',
                type: 'bold',
              },
              {
                text: '. Coba kita pahami ini dulu.',
              },
            ],
            [
              {
                text: 'Kata ',
              },
              {
                text: 'jaminan',
                type: 'bold',
              },
              {
                text: ' ini sangat penting karena kalau ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' ada bisa menimbulkan persepsi yang keliru. Disebut sebagai ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ', karena kata ',
              },
              {
                text: 'Bottom',
                type: 'bold-italic',
              },
              {
                text: ' merujuk pada “kapal” atau dengan kata lain kapal yang menjadi jaminannya.',
              },
            ],
          ],
        },
        {
          image: DataImage.mesopotamiaShip,
        },
        {
          paragraph: [
            [
              {
                text: 'Berbeda dengan zaman sekarang, praktik bisnis yang menggunakan barang yang dapat berpindah tempat sebagai jaminan, umumnya tidak memperbolehkan barang jaminan tersebut untuk digunakan, tapi tetap akan dirawat oleh si Pemberi pinjaman. Kita ambil contoh untuk ini adalah praktik gadai. Semisal, ',
              },
              {
                text: 'lo',
                type: 'italic',
              },
              {
                text: ' mau gadai motor maka motor tersebut ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' bisa digunakan selama masih dalam periode gadai karena khawatir kalau digunakan nanti mengalami kemerosotan nilai (depresiasi). Namun, untuk kasus ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' ini diperbolehkan menggunakan kapal walaupun kapal tersebut digunakan pula sebagai barang jaminan pada kontrak.',
              },
            ],
            [
              {
                text: 'Mungkin masih agak sedikit aneh ya. Kok ada sih orang minjem uang dengan jaminan kapal tapi untuk menggunakan kapalnya itu sendiri?',
              },
            ],
            [
              {
                text: 'Alasannya bisa bermacam-macam, salah satunya adalah karena biaya berlayar yang ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' murah. Peminjam membutuhkan modal tambahan karena terdapat banyak komponen biaya seperti menggaji awak kapal, membeli stok pangan, atau memperbaiki kerusakan/ menyelamatkan kapal pada saat di tengah perjalanan. Selain itu, Peminjam juga bisa membeli barang-barang dagangan dengan uang pinjamanya untuk di jual di tempat tujuan pelayaran. Hasil dagangan tersebut sebagian digunakan untuk membayar utang atas kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: '.',
              },
            ],
            [
              {
                text: 'Dalam praktiknya, terdapat pihak-pihak yang berkepentingan di dalam kontrak ini, yaitu:',
              },
            ],
          ],
        },
        {
          list: {
            content: [
              [
                {
                  text: 'The borrower',
                  type: 'italic',
                },
              ],
              {
                list: {
                  content: [
                    [
                      {
                        text: 'Pemilik Kapal',
                      },
                    ],
                    [
                      {
                        text: 'The master',
                        type: 'italic',
                      },
                      {
                        text: ' atau Nahkoda (jika ada/ opsional)',
                      },
                    ],
                  ],
                },
              },
              [
                {
                  text: 'The lender',
                  type: 'italic',
                },
              ],
              {
                list: {
                  content: [
                    [
                      {
                        text: 'Pemberi Pinjaman',
                      },
                    ],
                  ],
                },
              },
            ],
          },
        },
        {
          paragraph: [
            [
              {
                text: 'The master',
                type: 'italic',
              },
              {
                text: ' atau Nahkoda menjadi opsional karena bisa saja Pemilik kapal yang menjadi Nahkoda, atau Pemilik kapal memberi tugas kepada orang lain untuk menjadi Nahkoda dari kapalnya, atau ada orang yang memang berprofesi sebagai Nahkoda, tetapi menyewa kapal orang lain karena ia tidak punya kapal. Kondisi ini mirip seperti supir taksi di mana Supir tidak selalu yang mempunyai kendaraan, tapi mungkin ia dipekerjakan oleh perusahaan taksi, atau ia menyewa mobil untuk digunakan sebagai taksi.',
              },
            ],
            [
              {
                text: 'Dalam praktiknya, Pemilik kapal boleh membuat kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' di mana pun dan kapan pun, bahkan uang pinjamannya itu boleh dipakai bukan untuk menggunakan kapalnya. Hal ini jelas karena ia pemilik kapal jadi ya terserah dia. Di lain sisi, ',
              },
              {
                text: 'The master ',
                type: 'italic',
              },
              {
                text: ' tidak bisa secara bebas membuat kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' karena dia bukan pemilik kapal. ',
              },
              {
                text: 'The master ',
                type: 'italic',
              },
              {
                text: ' tidak boleh membuat kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' apabila:',
              },
            ],
          ],
        },
        {
          list: {
            content: [
              [
                {
                  text: 'Dia bisa memperoleh uang dengan cara lain. Sejak dulu memang sudah diajarkan untuk jauh-jauh dari utang piutang, tapi hal ini masih bisa ditolerir kalau dasar pernyataan ',
                },
                {
                  text: 'The master',
                  type: 'italic',
                },
                {
                  text: ' terbukti penting.',
                },
              ],
              [
                {
                  text: 'Dia bisa berkomunikasi dengan Pemilik kapal. Dengan kata lain, ia tidak boleh membuat kontrak ',
                },
                {
                  text: 'Bottomry',
                  type: 'ins-term',
                },
                {
                  text: ' di pelabuhan Pemilik kapal berada.',
                },
              ],
              [
                {
                  text: 'Dia bisa mendapatkan uang atau persediaan yang diperlukan atas kredit dirinya sendiri. Hal ini cukup jelas karena ia bukan pemilik kapal. Selain itu, akan menjadi masalah yang lebih besar jika setelah kontrak berakhir ia tidak bisa membayar utang.',
                },
              ],
            ],
          },
        },
        {
          paragraph: [
            [
              {
                text: 'Intinya, ',
              },
              {
                text: 'The master',
                type: 'italic',
              },
              {
                text: ' boleh membuat kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' tapi pada saat keadaan tertentu aja atau saat pinjaman benar-benar diperlukan untuk kelanjutan pelayaran yang aman. Tentu saja, ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: ' harus menyelidiki kebutuhan tersebut.',
              },
            ],
            [
              {
                text: 'Setelah kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' dibuat, nantinya akan ada tiga keputusan, yaitu:',
              },
            ],
          ],
        },
        {
          list: {
            content: [
              [
                {
                  text: 'Apabila kapal tidak selamat dan risiko penyebabnya termasuk atau tertulis dalam kontrak maka ',
                },
                {
                  text: 'The borrower',
                  type: 'italic',
                },
                {
                  text: ' otomatis terlepas dari utang.',
                },
              ],
              [
                {
                  text: 'Apabila kapal tidak selamat, tapi ',
                },
                {
                  text: 'The lender',
                  type: 'italic',
                },
                {
                  text: ' menganggap risiko penyebabnya tidak termasuk atau tidak tertulis dalam kontrak maka ',
                },
                {
                  text: 'The borrower',
                  type: 'italic',
                },
                {
                  text: ' memiliki ',
                },
                {
                  text: 'personal liable',
                  type: 'italic',
                },
                {
                  text: '.',
                },
              ],
              [
                {
                  text: 'Apabila kapal selamat maka ',
                },
                {
                  text: 'The borrower',
                  type: 'italic',
                },
                {
                  text: ' memiliki ',
                },
                {
                  text: 'personal liable',
                  type: 'italic',
                },
                {
                  text: '.',
                },
              ],
            ],
          },
        },
        {
          paragraph: [
            [
              {
                text: 'Personal liable',
                type: 'italic',
              },
              {
                text: ' secara harfiah memiliki arti "tanggung jawab pribadi". Hal ini mengartikan bahwa apabila ',
              },
              {
                text: 'The borrower',
                type: 'italic',
              },
              {
                text: ' tidak dapat membayar kembali uang pinjamannya beserta bunga maka barang jaminan (kapal) tersebut akan diambil hak miliknya oleh ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: '. Kemudian apabila masih belum cukup, bisa saja dirinya, keluarganya, atau barang-barangnya menjadi hak milik ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: '. ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: ' boleh menjadikannya budak atau keluarganya yang dijadikan budak dan sebagainya.',
              },
            ],
          ],
        },
        {
          image: DataImage.personalLiability,
        },
        {
          paragraph: [
            [
              {
                text: 'Menariknya kalau kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' dibuat oleh ',
              },
              {
                text: 'The master',
                type: 'italic',
              },
              {
                text: ' maka ia memilki ',
              },
              {
                text: 'personal liable',
                type: 'italic',
              },
              {
                text: ', sedangkan Pemilik kapal tidak. Pemilik kapal hanya bertanggung jawab atas nilai dari kapal yang dijamin itu. Di lain sisi, kalau kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' dibuat oleh Pemilik kapal ya sudah jelas dirinya juga ikut bertanggung jawab ',
              },
              {
                text: '(personal liable)',
                type: 'italic',
              },
              {
                text: ' kalau tidak bisa membayar uang pinjaman beserta bunga.',
              },
            ],
            [
              {
                text: 'Nah, hal tersebut adalah salah satu alasan kenapa ',
              },
              {
                text: 'The master nggak',
                type: 'italic',
              },
              {
                text: ' boleh membuat kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' secara bebas. ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: ' tidak memiliki jaminan (kapal) karena ',
              },
              {
                text: 'The master',
                type: 'italic',
              },
              {
                text: ' bukan pemilik kapal sehingga tidak dapat dianggap sebagai kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: '. Selain itu, ',
              },

              {
                text: 'The master',
                type: 'italic',
              },
              {
                text: ' akan menjadikan dirinya, keluarganya, atau barang-barangnya sebagai jaminan, sedangkan Pemilik kapal bebas dari ',
              },
              {
                text: 'personal liable',
                type: 'italic',
              },
              {
                text: '. Hal ini dikarenakan sejak awal perencanaan pelayaran seharusnya sudah diperhitungkan dengan matang dan tujuan dari kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' adalah untuk menggunakan kapal atau sesuatu yang berkaitan dengan kapal dan bukan selain itu meskipun Pemilik kapal itu sendiri boleh menggunakan uang pinjamannya untuk hal lain karena memang ia pemiliknya.',
              },
            ],
            [
              {
                text: 'Kalau ',
              },
              {
                text: 'lo',
                type: 'italic',
              },
              {
                text: ' masih bingung coba liat skema ini:',
              },
            ],
          ],
        },
        {
          image: DataImageMindMap.bagaimanaKontrakBottomryDijalankan,
        },
        {
          paragraph: [
            [
              {
                text: 'Perlu dicatat bahwa jaminan pada kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' tidak selalu berupa kapal, melainkan dapat berupa alat pengangkut lainnya. Bukti sejarah mencatat bahwa jalur darat adalah jalur transportasi pertama yang digunakan pada kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ', di mana pada waktu itu banyak pelancong atau pedagang dengan ',
              },
              {
                text: 'caravan',
                type: 'italic',
              },
              {
                text: ' yang dikenal sebagai ',
              },
              {
                text: 'Darmatha',
                type: 'italic',
              },
              {
                text: '.',
              },
            ],
          ],
        },
        {
          image: DataImage.arabianCaravan,
        },
      ],
    },
    {
      title: [
        {
          text: 'Respondia',
          type: 'italic',
        },
      ],
      content: [
        // {
        //   paragraph: [
        //     [
        //       {
        //         text: 'Definisi ',
        //       },
        //       {
        //         text: 'Respondia',
        //         type: 'ins-term',
        //       },
        //       {
        //         text: ' gue ',
        //         type: 'italic',
        //       },
        //       {
        //         text: ' ambil dari salah satu referensi yang bisa ',
        //       },
        //       {
        //         text: 'lo',
        //         type: 'italic',
        //       },
        //       {
        //         text: ' baca di bawah ini.',
        //       },
        //     ],
        //   ],
        // },
        {
          quote: {
            content: [
              {
                text: "When the loan is not on the ship, but on goods laden on board, which, from their nature, must be sold or exchanged in the course of the voyage, the borrower's personal responsibility is then the principal security for the performance of the contract, which is therefore called Respondentia.",
                type: 'italic',
              },
            ],
            author: {
              text: 'A TREATISE ON THE LAW OF MARINE INSURANCE, BOTTOMRY, AND RESPONDENTIA',
              path: 'https://books.google.co.id/books?id=qKlXAAAAcAAJ&dq=a%20treatise%20on%20the%20law%20of%20marine%20insurance%2C%20bottomry%2C%20and%20respondentia&lr&pg=PA574#v=onepage&q&f=true',
            },
          },
        },
        {
          paragraph: [
            [
              {
                text: 'Dari definisi di atas kita bisa ngejabarin bahwa ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' adalah sebuah kontrak di mana seseorang meminjam uang dengan jaminan barang-barang yang dimuat di kapal, tapi barang-barang tersebut memang sudah seharusnya dijual dalam perjalanannya sehingga tanggung jawab pribadi menjadi jaminan utama dalam kontrak.',
              },
            ],
            [
              {
                text: 'Disebut sebagai ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ', karena sebenarnya kata ',
              },
              {
                text: 'Respond',
                type: 'bold',
              },
              {
                text: ' merujuk pada “jaminan diri sendiri ',
              },
              {
                text: '(personal security/ personal liability)',
                type: 'italic',
              },
              {
                text: ' ” atau bisa kita bilang dirinya sendiri yang menjadi jaminannya.',
              },
            ],
            [
              {
                text: 'Loh kok gitu? Tadi katanya atas jaminan barang, kok sekarang jaminan diri sendiri?',
              },
            ],
            [
              {
                text: 'Flashback ',
                type: 'italic',
              },
              {
                text: ' sedikit, pada kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' yang dijadikan sebagai jaminan adalah kapal dan ',
              },
              {
                text: ' The lender ',
                type: 'italic',
              },
              {
                text: ' berharap kedatangan kapal tersebut agar bisa memperoleh kembali uangnya beserta bunga. Jika ',
              },
              {
                text: ' The borrower ',
                type: 'italic',
              },
              {
                text: ' tidak bisa membayar utang beserta bunga maka barang jaminan (kapal) akan diambil.',
              },
            ],
            [
              {
                text: 'Di lain sisi, pada kontrak ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' yang dijadikan sebagai jaminan adalah barang dagangan. Hampir ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' mungkin ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: ' berharap kedatangan barang dagangan tersebut agar bisa memperoleh kembali uangnya beserta bunga. Hampir ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' mungkin juga barang dagangan tersebut yang diambil jika tidak bisa membayar utang beserta bunga. Hal ini dikarenakan hakekat dari barang dagangan yang memang untuk dijual atau ditukar dengan sesuatu. Artinya akan ada perpindahan tangan padahal barang tersebut itu sedang dijadikan sebagai jaminan. Dengan kata lain, ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: ' hampir ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' mungkin berharap barang tersebut tidak laku atau tidak ada yang mau membeli. Dalam beberapa kasus mungkin bisa terjadi, tapi umumnya barang dagangan akan terjual. Maka dari itu, ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: ' akan langsung bergantung pada ',
              },
              {
                text: 'personal liability',
                type: 'italic',
              },
              {
                text: ' karena kecil kemungkinan atau ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' ada harapan barang dagangan itu kembali.',
              },
            ],
            [
              {
                text: 'Di sini gue bilang “…hampir nggak mungkin…” atau “…kecil kemungkinan…” karena memang masih bisa terjadi di mana barang dagangan tersebut ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' laku. Dalam kasus seperti ini ',
              },
              {
                text: 'The borrower',
                type: 'italic',
              },
              {
                text: ' tidak akan langsung memiliki ',
              },
              {
                text: 'personal liability',
                type: 'italic',
              },
              {
                text: ' walaupun ia tidak dapat membayar kembali uang pinjamannya beserta bunga. ',
              },
              {
                text: 'The borrower',
                type: 'italic',
              },
              {
                text: ' dapat mengembalikan hutang beserta bunganya dengan memberikan ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: ' barang dagangannya yang tidak laku tersebut. Jika barang dagangan tersebut sudah terjual maka ',
              },
              {
                text: 'The borrower',
                type: 'italic',
              },
              {
                text: ' bisa membayarnya dengan uang atau barang dagangan lain yang dibeli dari hasil penjualan barang dagangan sebelumnya entah itu dalam perjalanan pergi atau kembali, yang terpenting adalah barang tersebut bernilai sama dengan yang ada pada kontrak. Jika tetap tidak bisa, barang-barang milik ',
              },
              {
                text: 'The borrower',
                type: 'italic',
              },
              {
                text: ' akan diambil oleh ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: '. Kemudian jika tetap tidak bisa atau tidak cukup, ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: ' mungkin saja menjadikan ',
              },
              {
                text: 'The borrower',
                type: 'italic',
              },
              {
                text: ' atau keluarganya sebagai budak.',
              },
            ],
            [
              {
                text: 'Lagi pula, baik ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' maupun ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' pada akhirnya akan menggunakan ',
              },
              {
                text: 'personal liability',
                type: 'italic',
              },
              {
                text: ' kalau tidak bisa membayar uang pinjaman beserta bunga. Hanya saja pada kontrak ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' akan kurang memungkinkan kalau hanya bergantung ke barang dagangan sehingga langsung melekat pada ',
              },
              {
                text: 'personal liability',
                type: 'italic',
              },
              {
                text: '.',
              },
            ],
            [
              {
                text: 'Jadi jangan bingung ya kenapa kata ',
              },
              {
                text: 'Respond ',
                type: 'bold',
              },
              {
                text: ' merujuk pada ',
              },
              {
                text: 'personal security',
                type: 'italic',
              },
              {
                text: ' atau ',
              },
              {
                text: 'personal liability',
                type: 'italic',
              },
              {
                text: ' walaupun ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' itu sendiri menggunakan barang dagangan sebagai barang jaminan.',
              },
            ],
            [
              {
                text: 'Oiya Barang dagangan pada kontrak ini bermacam-macam mulai dari tanah liat (batu bata), perunggu, tekstil, minyak, ikan, hingga biji-bijian.',
              },
            ],
          ],
        },
        {
          image: DataImage.goodsRespondia,
        },
        {
          paragraph: [
            [
              {
                text: 'Dalam praktik pembuatan kontraknya mirip dengan ',
              },

              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' di mana ',
              },
              {
                text: 'The master',
                type: 'italic',
              },
              {
                text: ' hanya boleh membuat kontrak pada saat-saat tertentu saja atau saat pinjaman benar benar dibutuhkan. Keputusan di ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' juga hampir sama seperti di ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ', bedanya ada tambahan keputusan yaitu apabila kapal tidak selamat, hilang, atau hancur, tetapi ',
              },
              {
                text: 'The borrower',
                type: 'italic',
              },
              {
                text: ' selamat sampai tujuan kembali maka ',
              },
              {
                text: 'The borrower',
                type: 'italic',
              },
              {
                text: ' tetap harus bertanggung jawab. Loh kok gitu? Ya karena itu tadi, yang dijadikan sebagai jaminan dalam ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' ini adalah barang dagangan jadi ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' ada kaitannya sama kapal.',
              },
            ],
            [
              {
                text: 'Tapi kan kalau kapal ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' selamat berarti barang-barangnya juga ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' selamat dong?',
              },
            ],
            [
              {
                text: 'Ya iya sih, tapi pada dasarnya kontrak ini merujuk pada ',
              },
              {
                text: 'personal liability',
                type: 'italic',
              },
              {
                text: ' yang artinya kalau ',
              },
              {
                text: 'The borrower',
                type: 'italic',
              },
              {
                text: ' selamat ya dia harus bertanggung jawab.',
              },
            ],
          ],
        },
      ],
    },
    {
      title: [
        {
          text: 'Intermezzo',
        },
      ],
      content: [
        {
          paragraph: [
            [
              {
                text: 'For your information',
                type: 'italic',
              },
              {
                text: '. Sebelum kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' dan ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' muncul, ada sebuah ',
              },
              {
                text: 'agreement',
                type: 'italic',
              },
              {
                text: ' atau perjanjian yang biasa digunakan para pedagang. ',
              },
              {
                text: 'Agreement',
                type: 'italic',
              },
              {
                text: ' ini bisa dibilang kejam dan ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' sebaik ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' dan ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' yang kita kenal.',
              },
              {
                text: ' Kalau mau tau jelasnya, ',
              },
              {
                text: 'lo',
                type: 'italic',
              },
              {
                text: ' bisa baca tulisan ',
              },
              {
                text: 'gue',
                type: 'italic',
              },
              {
                text: ' yang membahas tentang ini di ',
              },
              {
                text: 'Mengenal Lebih Dalam Sejarah Asuransi',
                type: 'link-page',
                path: DataLinkPage.edu_mengenalLebihDalamSejarahAsuransi,
              },
              {
                text: '.',
              },
            ],
            [
              {
                text: 'Singkatnya, ',
              },
              {
                text: 'agreement',
                type: 'italic',
              },
              {
                text: ' tersebut ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' peduli akan adanya serangan perampokan atau kesalahan yang bukan kesengajaan (bukan kelalaian). Dengan kata lain ',
              },
              {
                text: 'The borrower',
                type: 'italic',
              },
              {
                text: ' tetap harus membayar kembali uang pinjaman beserta bunga.',
                type: 'italic',
              },
            ],
          ],
        },
        {
          image: DataImage.ancientGreekPirates,
        },
        {
          paragraph: [
            [
              {
                text: 'Udah kapalnya dirampok, hilang, hancur terus sampe rumah ditagih utang lagi, hadeh… Tapi ya, ',
              },
              {
                text: 'agreement',
                type: 'italic',
              },
              {
                text: ' ini kemudian dibenahi dan diberi kekuatan hukum dalam ',
              },
              {
                text: 'Code of Hammurabi',
                type: 'link',
                path: 'https://www.history.com/topics/ancient-history/hammurabi',
              },
              {
                text: ' khususnya pada pasal 104 yang berbunyi:',
              },
            ],
          ],
        },
        {
          quote: {
            content: [
              {
                text: '104. If a merchant give an agent corn, wool, oil, or any other goods to transport, the agent shall give a receipt for the amount, and compensate the merchant therefor. Then he shall obtain a receipt form the merchant for the money that he gives the merchant.',
                type: 'italic',
              },
            ],
            author: {
              text: 'CODE OF HAMMURABI',
              path: 'https://avalon.law.yale.edu/ancient/hamframe.asp',
            },
          },
        },
        {
          image: DataImage.codeTabletHammurabi,
        },
        {
          paragraph: [
            [
              {
                text: 'Sejak saat itu, perjanjian ini menjadi ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' dan ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },

              {
                text: ' yang kita kenal dan berkembang menjadi asuransi modern hingga sekarang.',
              },
            ],
          ],
        },
      ],
    },
    {
      title: [
        {
          text: 'Hubungannya dengan asuransi',
        },
      ],
      content: [
        {
          paragraph: [
            [
              {
                text: 'Oke kita udah sampe di penghujung pembicaraan, apa sih hubungannya dengan asuransi modern?',
              },
            ],
            [
              {
                text: 'Simpelnya, ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' dan ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' merupakan cikal bakal dari asuransi modern atau asuransi masa kini. Keduanya memiliki esensi yang sama yaitu ',
              },
              {
                text: 'harus terdapat risiko',
                type: 'bold',
              },
              {
                text: ', tapi apakah risiko itu benar terjadi atau kapan risiko itu terjadi itu masalah nanti.',
              },
            ],
            [
              {
                text: 'Dalam asuransi modern, salah satu jenis risiko yang dapat diasuransikan adalah ',
              },
              {
                text: 'pure risk',
                type: 'bold-italic',
              },
              {
                text: ' yaitu risiko yang apabila terjadi maka hanya akan mendatangkan kerugian. Asuransi tidak akan menerima risiko yang apabila terjadi akan mendatangkan dua kemungkinan yaitu kerugian atau keuntungan, jenis risiko ini disebut juga sebagai ',
              },
              {
                text: 'speculative risk',
                type: 'bold-italic',
              },
              {
                text: '. Berbeda dengan kontrak mirip asuransi, dalam ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' dan ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' dikenal istilah ',
              },
              {
                text: 'should be exposed to the perils of the sea (the risk)',
                type: 'bold-italic',
              },
              {
                text: ' sehingga ',
              },
              {
                text: 'The borrower',
                type: 'italic',
              },
              {
                text: ' harus menghabiskan pinjamannya untuk melakukan pelayaran atau perjalanan, baik itu membeli barang dagangan, memperbaiki kapal, menyewa awak kapal, dan lain sebagainya yang pasti akan berhadapan dengan risiko-risiko dalam perjalanan itu sendiri, seperti ombak laut, kebakaran, perampokan, dan lain-lain. Jika tidak berhadapan dengan risiko maka dianggap sebagai kontrak pinjaman biasa.',
              },
            ],
            [
              {
                text: 'Dari adanya risiko tersebut kemudian dilakukanlah pengalihan risiko ',
              },
              {
                text: '(transfer of risk)',
                type: 'italic',
              },
              {
                text: '. Risiko yang ada pada ',
              },
              {
                text: 'The borrower',
                type: 'italic',
              },
              {
                text: ' akan dialihkan kepada ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: ', begitu juga dengan risiko yang ada pada Tertanggung (nasabah asuransi) yang akan dialihkan ke Perusahaan asuransi. Namun, risiko pada kontrak ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' dan ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' hanya terkonsentrasi pada ',
              },
              {
                text: 'Perils on The Sea & Perils of The Sea',
                type: 'link',
                path: 'https://ahliasuransi.com/perils-of-the-seas-v-perils-on-the-seas/',
              },
              {
                text: ', sedangkan asuransi modern sudah lebih luas lagi.',
              },
            ],
          ],
        },
        {
          image: DataImage.stormAtSea,
        },
        {
          paragraph: [
            [
              {
                text: 'Asuransi modern memiliki cara kerja di mana premi dibayarkan terlebih dahulu kemudian klaim akan dibayarkan jika risiko terjadi dan sesuai kontrak polis, tapi klaim tidak akan dibayarkan jika risiko tidak terjadi. Lain hal dengan ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' dan ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ', kontrak ini memiliki cara kerja di mana “klaim” dibayarkan terlebih dahulu, kemudian “klaim” tersebut akan dikembalikan ditambah dengan “premi" jika risiko tidak terjadi, tapi tidak akan dibayarkan jika risiko terjadi dan sesuai kontrak.',
              },
            ],
            [
              {
                text: '“Klaim” pada ',
              },
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' dan ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' merujuk pada uang pinjaman, sedangkan “premi” merujuk pada tambahan bunga yang berlaku. Nah biar mudah pahaminnya, coba liat gambar di bawah ini.',
              },
            ],
          ],
        },
        {
          image:
            DataImageMindMap.perbandinganBottomryRespondiaDenganAsuransiModern,
        },
        {
          paragraph: [
            [
              {
                text: 'Bagian yang terpenting dari asuransi modern dan praktik mirip asuransi adalah keduanya diwajibkan untuk melekatkan klausul (peraturan) sejelas mungkin dalam kontraknya. Hal ini bertujuan apabila terjadi ',
              },
              {
                text: 'despute',
                type: 'italic',
              },
              {
                text: ' (perselisihan) antara Tertanggung dengan Perusahaan Asuransi atau ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: ' dengan ',
              },
              {
                text: 'The borrower',
                type: 'italic',
              },
              {
                text: ' maka dapat terselesaikan dengan baik dan cepat.',
              },
            ],
            [
              {
                text: 'Contoh studi kasus gue ambil dari ',
              },
              {
                text: 'Busk v Fearon and Others',
                type: 'link',
                path: 'https://books.google.co.id/books?id=AuEvAAAAIAAJ&lpg=PA444&dq=fearon%20and%20douglas%20respondentia&pg=PA444#v=onepage&q&f=true',
              },
              {
                text: ' yang bisa ',
              },
              {
                text: 'lo',
                type: 'italic',
              },
              {
                text: ' baca di artikel selanjutnya ',
              },
              {
                text: 'Mengapa halaman polis asuransi sangat banyak?',
                type: 'link-page',
                path: DataLinkPage.edu_mengapaHalamanPolisSangatBanyak,
              },
              {
                text: '. Singkatnya, Busk ',
              },
              {
                text: '(The lender)',
                type: 'italic',
              },
              {
                text: ' gagal memiliki hak atas barang yang dibeli Fearon ',
              },
              {
                text: '(The borrower)',
                type: 'italic',
              },
              {
                text: ' dari hasil pinjamannya karena Busk kurang teliti dan detail dalam membuat klausul pada kontrak. Pengadilan memutuskan bahwa kontrak ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' yang dibuat oleh kedua pihak seharusnya mencantumkan klausul yang detail terkait bagian dari hak jaminan yang dimiliki ',
              },
              {
                text: 'The lender',
                type: 'italic',
              },
              {
                text: ' walaupun hal tersebut "dianggap" menjadi sifat alami dari sebuah kontrak ',
              },
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: '. Pengadilan mengatakan bahwa sebuah kontrak harus ditafsirkan berdasarkan isi kontrak tersebut dan bukan berdasarkan sifat umum. Hal ini sebagai pertimbangan atas perbedaan hukum di berbagai wilayah dan perbedaan pengetahuan setiap orang akan sifat umum tersebut.',
              },
            ],
            [
              {
                text: 'Oiya, perlu dicatat bahwa ini semua tergantung pada kontrak yang disepakati sehingga dapat berbeda satu sama lain. Kontrak yang dijelaskan di sini adalah kontrak yang berlaku pada umumnya.',
              },
            ],
          ],
        },
      ],
    },
  ],
  conclusion: {
    title: [
      {
        text: 'Kesimpulan',
      },
    ],
    content: [
      {
        paragraph: [
          [
            {
              text: 'Kontrak ',
            },
            {
              text: 'Bottomry',
              type: 'ins-term',
            },
            {
              text: ' dan ',
            },
            {
              text: 'Respondia',
              type: 'ins-term',
            },
            {
              text: ' merupakan praktik mirip asuransi yang menjadi cikal bakal dari asuransi modern atau asuransi masa kini.',
            },
          ],
        ],
      },
      {
        list: {
          content: [
            [
              {
                text: 'Bottomry',
                type: 'ins-term',
              },
              {
                text: ' adalah sebuah kontrak di mana seseorang meminjam uang untuk menggunakan kapalnya dengan jaminan kapalnya itu sendiri kepada orang lain, dengan ketentuan apabila dalam perjalanan kapal itu hilang maka Pemberi pinjaman juga kehilangan uang yang dia pinjamkan tadi, tapi apabila kapal itu selamat maka Pemberi pinjaman akan menerima kembali uang tadi beserta bunga.',
              },
            ],
            [
              {
                text: 'Respondia',
                type: 'ins-term',
              },
              {
                text: ' adalah sebuah kontrak di mana seseorang meminjam uang dengan jaminan barang-barang yang dimuat di kapal yang sudah seharusnya dijual dalam perjalanannya sehingga tanggung jawab pribadi menjadi jaminan utama dalam kontrak.',
              },
            ],
          ],
        },
      },
    ],
  },
};

export default DataArticle;
